import { render } from "./AlertItem.vue?vue&type=template&id=fd01cce2"
import script from "./AlertItem.vue?vue&type=script&lang=js"
export * from "./AlertItem.vue?vue&type=script&lang=js"

import "./AlertItem.vue?vue&type=style&index=0&id=fd01cce2&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__